import { createRouter, createWebHistory } from 'vue-router'
import CryptoJS from 'crypto-js'
import { inject } from 'vue'

const routes = [
  {
    path: '/',
    name: 'Login',
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/acesso-negado',
    name: 'AcessoNegado',
    component: () => import('@/views/AcessoNegado.vue')
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/Home.vue')
  },
  {
    path: '/acompanhamento-ocorrencia/:id',
    name: 'AcompanhamentoOcorrencia',
    component: () => import('@/views/ocorrencia/AcompanhamentoOcorrencia.vue'),
    meta: { publica: true },
  },
  {
    path: '/servico-solicitado-detalhe/:servicoSolicitadoDetalheId/servico-executado-detalhe',
    name: 'ServicoSolicitadoServicoExecutado',
    component: () => import('@/views/configuracoes/ServicoSolicitadoServicoExecutado.vue'),
  },
  {
    path: '/unidade-medida-pavimento',
    name: 'UnidadeMedidaPavimento',
    component: () => import('@/views/configuracoes/UnidadeMedidaPavimento.vue')
  },
  {
    path: '/relatorio-pavimentacao',
    name: 'RelatorioPavimentacao',
    component: () => import('@/views/relatorios/RelatorioPavimentacao.vue')
  },
  {
    path: '/relatorio-reclamacao',
    name: 'RelatorioReclamacao',
    component: () => import('@/views/relatorios/RelatorioReclamacao.vue')
  },
  {
    path: '/tempo-medio',
    name: 'RelatorioTempoMedio',
    component: () => import('@/views/relatorios/RelatorioTempoMedio.vue')
  },
  {
    path: '/materiais-por-equipe',
    name: 'RelatorioMateriaisEquipe',
    component: () => import('@/views/relatorios/RelatorioMateriaisEquipe.vue')
  },
  {
    path: '/rede-agua-esgoto',
    name: 'RelatorioRedeAguaEsgoto',
    component: () => import('@/views/relatorios/RelatorioRedeAguaEsgoto.vue')
  },
  {
    path: '/biblioteca-categoria',
    name: 'BibliotecaCategoria',
    component: () => import('@/views/configuracoes/BibliotecaCategoria.vue')
  },
  {
    path: '/biblioteca-acao',
    name: 'BibliotecaAcao',
    component: () => import('@/views/configuracoes/BibliotecaAcao.vue')
  },
  {
    path: '/fluxo-acao',
    name: 'FluxoAcao',
    component: () => import('@/views/configuracoes/FluxoAcao.vue')
  },
  {
    path: '/fluxo-acao/:fluxoAcaoId/servicos',
    name: 'FluxoAcaoServico',
    component: () => import('@/views/configuracoes/FluxoAcaoServico.vue')
  },
  {
    path: '/ocorrencia-arquivos',
    name: 'OcorrenciaArquivos',
    component: () => import('@/views/ocorrencia/OcorrenciaArquivos.vue')
  },
  {
    path: '/fluxo-servico',
    name: 'FluxoServico',
    component: () => import('@/views/configuracoes/FluxoServico.vue')
  },
  {
    path: '/impressao-ocorrencia',
    name: 'ImpressaoOcorrencia',
    component: () => import('@/views/ocorrencia/ImpressaoOcorrencia.vue')
  },
  {
    path: '/referencia-rede',
    name: 'ReferenciaRede',
    component: () => import('@/views/configuracoes/ReferenciaRede.vue')
  },
  {
    path: '/posicao-rede',
    name: 'PosicaoRede',
    component: () => import('@/views/configuracoes/PosicaoRede.vue')
  },
  {
    path: '/tipo-material-rede',
    name: 'TipoMaterialRede',
    component: () => import('@/views/configuracoes/TipoMaterialRede.vue')
  },
  {
    path: '/diametro-rede',
    name: 'DiametroRede',
    component: () => import('@/views/configuracoes/DiametroRede.vue')
  },
  {
    path: '/manobra-ocorrencia',
    name: 'ManobraOcorrencia',
    component: () => import('@/views/configuracoes/ManobraOcorrencia.vue')
  },
  {
    path: '/maquinario',
    name: 'Maquinario',
    component: () => import('@/views/configuracoes/Maquinario.vue')
  },
  {
    path: '/material',
    name: 'Material',
    component: () => import('@/views/configuracoes/Material.vue')
  },
  {
    path: '/unidade',
    name: 'Unidade',
    component: () => import('@/views/configuracoes/Unidade.vue')
  },
  {
    path: '/adutora',
    name: 'Adutora',
    component: () => import('@/views/configuracoes/Adutora.vue')
  },
  {
    path: '/regiao',
    name: 'Regiao',
    component: () => import('@/views/configuracoes/Regiao.vue')
  },
  {
    path: '/regiao-domasa',
    name: 'RegiaoDomasa',
    component: () => import('@/views/configuracoes/RegiaoDomasa.vue')
  },
  {
    path: '/motivo-cancelamento',
    name: 'MotivoCancelamento',
    component: () => import('@/views/configuracoes/MotivoCancelamento.vue')
  },
  {
    path: '/gestao-manobras',
    name: 'GestaoManobras',
    component: () => import('@/views/gestao-manobras/GestaoManobras.vue')
  },
  {
    path: '/lista-ocorrencia',
    name: 'ListaOcorrencia',
    component: () => import('@/views/ListaOcorrencia.vue')
  },
  {
    path: '/operacao',
    name: 'Operacao',
    component: () => import('@/views/Operacao.vue')
  },
  {
    path: '/detalhar-ocorrencia/:id',
    name: 'DetalharOcorrencia',
    component: () => import('@/views/DetalharOcorrencia.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/detalhes-ocorrencia/:id',
    name: 'DetalhesOcorrencia',
    component: () => import('@/views/DetalhesOcorrencia.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/modulos',
    name: 'Modulos',
    component: () => import('@/views/configuracoes/Modulos.vue')
  },
  {
    path: '/telas',
    name: 'Telas',
    component: () => import('@/views/configuracoes/Telas.vue')
  },
  {
    path: '/perfil',
    name: 'Perfil',
    component: () => import('@/views/seguranca/Perfil.vue')
  },
  {
    path: '/perfil/:perfilId/telas',
    name: 'PerfilTelas',
    component: () => import('@/views/seguranca/PerfilTelas.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/perfil/:perfilId/destinatarios',
    name: 'PerfilDestinatario',
    component: () => import('@/views/seguranca/PerfilDestinatario.vue'),
  },
  {
    path: '/perfil/:perfilId/perfil-servico-executado-detalhe',
    name: 'PerfilServicoExecutadoDetalhe',
    component: () => import('@/views/seguranca/PerfilServicoExecutadoDetalhe.vue'),
  },
  {
    path: '/perfil/:perfilId/perfil-servico-solicitado-detalhe',
    name: 'PerfilServicoSolicitadoDetalhe',
    component: () => import('@/views/seguranca/PerfilServicoSolicitadoDetalhe.vue'),
  },
  {
    path: '/perfil/:perfilId/perfil-horario-acesso',
    name: 'PerfilHorariosAcesso',
    component: () => import('@/views/seguranca/PerfilHorarioAcesso.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/usuario',
    name: 'Usuario',
    component: () => import('@/views/seguranca/Usuario.vue')
  },
  {
    path: '/ocorrencia-tabs',
    name: 'OcorrenciaTabs',
    component: () => import('@/views/OcorrenciaTabs.vue')
  },
  {
    path: '/nova-ocorrencia',
    name: 'NovaOcorrencia',
    component: () => import('@/views/NovaOcorrencia.vue')
  },
  {
    path: '/abertura-reclamacao',
    name: 'AberturaReclamacao',
    component: () => import('@/views/AberturaReclamacao.vue')
  },
  {
    path: '/consulta-ocorrencia',
    name: 'ConsultaOcorrencia',
    component: () => import('@/views/ConsultaOcorrencia.vue')
  },
  {
    path: '/categoria-servico',
    name: 'CategoriaServico',
    component: () => import('@/views/configuracoes/CategoriaServico.vue')
  },
  {
    path: '/destinatario',
    name: 'Destinatario',
    component: () => import('@/views/configuracoes/Destinatario.vue')
  },
  {
    path: '/servico-executado',
    name: 'ServicoExecutado',
    component: () => import('@/views/configuracoes/ServicoExecutado.vue')
  },
  {
    path: '/servico-solicitado',
    name: 'ServicoSolicitado',
    component: () => import('@/views/configuracoes/ServicoSolicitado.vue')
  },
  {
    path: '/servico-executado-detalhe',
    name: 'ServicoExecutadoDetalhe',
    component: () => import('@/views/configuracoes/ServicoExecutadoDetalhe.vue')
  },
  {
    path: '/servico-solicitado-detalhe',
    name: 'ServicoSolicitadoDetalhe',
    component: () => import('@/views/configuracoes/ServicoSolicitadoDetalhe.vue')
  },
  {
    path: '/quadro-avisos',
    name: 'QuadroAvisos',
    component: () => import('@/views/gestao-manobras/PainelManobra.vue')
  },
  {
    path: '/pop',
    name: 'Pop',
    component: () => import('@/views/configuracoes/Pop.vue')
  },
  {
    path: '/pop/:popId/categoria-servico',
    name: 'PopCategoriaServico',
    component: () => import('@/views/configuracoes/PopCategoriaServico.vue')
  },
  {
    path: '/pop/:popId/servico-solicitado',
    name: 'PopServicoSolicitado',
    component: () => import('@/views/configuracoes/PopServicoSolicitado.vue')
  },
  {
    path: '/pop/:popId/servico-solicitado-detalhe',
    name: 'PopServicoSolicitadoDetalhe',
    component: () => import('@/views/configuracoes/PopServicoSolicitadoDetalhe.vue')
  },
  {
    path: '/pop-pergunta',
    name: 'PopPergunta',
    component: () => import('@/views/configuracoes/PopPergunta.vue')
  },
  {
    path: '/agendamento',
    name: 'Agendamento',
    component: () => import('@/views/configuracoes/Agendamento.vue')
  },
  {
    path: '/cargo',
    name: 'Cargo',
    component: () => import('@/views/configuracoes/Cargo.vue')
  },
  {
    path: '/setor',
    name: 'Setor',
    component: () => import('@/views/configuracoes/Setor.vue')
  },
  {
    path: '/tipo-funcionario',
    name: 'TipoFuncionario',
    component: () => import('@/views/configuracoes/TipoFuncionario.vue')
  },
  {
    path: '/veiculo',
    name: 'Veiculo',
    component: () => import('@/views/configuracoes/Veiculo.vue')
  },
  {
    path: '/funcionario',
    name: 'Funcionario',
    component: () => import('@/views/configuracoes/Funcionario.vue')
  },
  {
    path: '/equipe',
    name: 'Equipe',
    component: () => import('@/views/configuracoes/Equipe.vue')
  },
  {
    path: '/manobra-categoria',
    name: 'ManobraCategoria',
    component: () => import('@/views/configuracoes/ManobraCategoria.vue')
  },
  {
    path: '/manobra-tipo-servico',
    name: 'ManobraTipoServico',
    component: () => import('@/views/configuracoes/ManobraTipoServico.vue')
  },
  {
    path: '/manobra-tipo-obra',
    name: 'ManobraTipoObra',
    component: () => import('@/views/configuracoes/ManobraTipoObra.vue')
  },
  {
    path: '/manutencao-eletro-mecanica',
    name: 'Eletromecanica',
    component: () => import('@/views/Eletromecanica.vue')
  },
  {
    path: '/contas-energia',
    name: 'ContasEnergia',
    component: () => import('@/views/ContasEnergia.vue')
  },
  {
    path: '/mapa-ocorrencias',
    name: 'MapaOcorrencias',
    component: () => import('@/views/MapaOcorrencias.vue')
  },
  {
    path: '/dash-continuidade-abastecimento',
    name: 'ContinuidadeAbastecimento',
    component: () => import('@/views/dashboards/ContinuidadeAbastecimento.vue')
  },
  {
    path: '/dash-reclamacoes-usuarios',
    name: 'ReclamacoesUsuarios',
    component: () => import('@/views/dashboards/ReclamacoesUsuarios.vue')
  },
  {
    path: '/dash-sla-regulatorio',
    name: 'SlaRegulatorio',
    component: () => import('@/views/dashboards/SlaRegulatorio.vue')
  },
  {
    path: '/dash-eficiencia-operacional',
    name: 'EficienciaOperacional',
    component: () => import('@/views/dashboards/EficienciaOperacional.vue')
  },
  {
    path: '/dash-condicao-da-rede',
    name: 'CondicaoRede',
    component: () => import('@/views/dashboards/CondicaoRede.vue')
  },
  {
    path: '/dash-qualidade-tratamento',
    name: 'QualidadeTratamento',
    component: () => import('@/views/dashboards/QualidadeTratamento.vue')
  },
  {
    path: '/dash-controle-consumo',
    name: 'ControleConsumo',
    component: () => import('@/views/dashboards/ControleConsumo.vue')
  },
  {
    path: '/dash-cobertura-servico',
    name: 'CoberturaServico',
    component: () => import('@/views/dashboards/CoberturaServico.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeResolve((to, from, next) => {
  const rotasPublicas = ['/acompanhamento-ocorrencia']
  const ehRotaPublica = rotasPublicas.some(rp => to.path.startsWith(rp))
  if (ehRotaPublica) { next(); return }

  if (to.path === '/') {
    next()
  }
  else if (!localStorage.getItem('loginNovoSanegeo')) {
    localStorage.setItem('rotaNavegacao', to.fullPath)
    next('/')
  } else {
    const bytes = CryptoJS.AES.decrypt(localStorage.getItem('loginNovoSanegeo'), inject('chaveSeguranca'))
    const login = JSON.parse(bytes.toString(CryptoJS.enc.Utf8))

    // array de rotas permitidas
    let rotasLiberadas = ['/ocorrencia-tabs']
    login.data.usuario.modulos?.forEach(modulo => {
      //rotasLiberadas.push(modulo.urlControle) => vou controlar no componente e menu
      modulo.telas?.forEach(tela => rotasLiberadas.push(tela.url)) //Informações de acesso do backend
    })

    // Função de match que suporta rotas com parâmetros (:id) e wildcard (*)
    const matchesAllowed = (path, allowed) => {
      if (!Array.isArray(allowed)) return false;
      // 1) Bate exato primeiro
      if (allowed.includes(path)) return true;
      // 2) Converte padrões tipo "/perfil/:perfilId/telas" em regex: ^/perfil/[^/]+/telas$
      const toRegex = (pattern) => {
        if (!pattern || typeof pattern !== 'string') return null;
        // Escapa especiais, preservando ":" e "*"
        let s = pattern.replace(/[.+?^${}()|[\]\\]/g, '\\$&');
        // ":param" -> [^/]+
        s = s.replace(/:([^/]+)/g, '[^/]+');
        // "*" -> ".*" (se algum dia o backend enviar)
        s = s.replace(/\*/g, '.*');
        return new RegExp(`^${s}$`);
      };
      return allowed.some(p => {
        const rx = toRegex(p);
        return rx ? rx.test(path) : false;
      });
    };

    const podeAcessar = matchesAllowed(to.path, rotasLiberadas) || to.path === '/acesso-negado';
    next(podeAcessar ? undefined : '/acesso-negado');
  }
})

export default router